import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { AuthenticationCardWrapper } from '../AuthenticationCardWrapper';
import { ForgotPasswordEmailInput } from './ForgotPasswordEmailInput';
import { ResetPasswordWithVerification } from './ResetPasswordWithVerification';

const trackOTPEvents = createAnalyticsTracker('otpViewNav');

export const ForgotPasswordContainer = () => {
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [email, setEmail] = useState('');

  const navigate = useNavigate();

  const onGoBackFromResetPasswordPage = () => {
    trackOTPEvents({ eventName: 'Back from Forget Password' });
    setIsEmailVerified(false);
  };

  const onGoBackFromEmailInputPage = () => {
    trackOTPEvents({ eventName: 'Change Email for New OTP', email });
    navigate(-1);
  };

  if (isEmailVerified) {
    return (
      <AuthenticationCardWrapper onGoBack={onGoBackFromResetPasswordPage}>
        <ResetPasswordWithVerification email={email} />
      </AuthenticationCardWrapper>
    );
  }

  return (
    <AuthenticationCardWrapper onGoBack={onGoBackFromEmailInputPage}>
      <ForgotPasswordEmailInput
        email={email}
        setEmail={setEmail}
        setIsEmailVerified={setIsEmailVerified}
      />
    </AuthenticationCardWrapper>
  );
};
